import styled from 'styled-components'
import colors from '../../utils/style/colors'

import Container from 'react-bootstrap/Container';

export const HeaderContainer = styled(Container) `
    border-bottom: 2px solid ${colors.tertary};
`